import { put, call, all, takeLatest, select } from 'redux-saga/effects'
import services from '../../services'

import {
  GetOneContact,
  GET_ONE_CONTACT,
  GET_ONE_CONTACT_ERROR,
  GET_ONE_CONTACT_SUCCESS,
} from '../types/contact/get-one'

import {
  GetAllContacts,
  GET_ALL_CONTACTS,
  GET_ALL_CONTACTS_ERROR,
  GET_ALL_CONTACTS_SUCCESS,
  UPDATE_CONTACTS,
} from '../types/contact/get-all'

import {
  NewContact,
  NEW_CONTACT,
  NEW_CONTACT_ERROR,
  NEW_CONTACT_SUCCESS,
} from '../types/contact/new'

import {
  EditContact,
  EDIT_CONTACT,
  EDIT_CONTACT_ERROR,
  EDIT_CONTACT_SUCCESS,
} from '../types/contact/edit'

import {
  DeleteContact,
  DELETE_CONTACT,
  DELETE_CONTACT_ERROR,
  DELETE_CONTACT_SUCCESS,
} from '../types/contact/delete'

const getAllCurrentContacts = ({ contactStore }) => contactStore.all.data

const removeContactFeaturedFlag = async ({ payload, currentContacts }) => {
  console.log('removeContactFeaturedFlag', payload)
  try {
    const featuredContact = currentContacts.data.find(item => item.type === payload.type && item.featured)

    if (featuredContact) {
      const { response, error } = await services.contact.edit({
        idContact: featuredContact?._id,
        body: { featured: false },
      })

      if (error) {
        console.error('Error in removeContactFeaturedFlag', error)
        return null
      } else {
        console.log({ response })
        return response
      }
    }
  } catch {
    console.error('Error in removeContactFeaturedFlag')
  }
}

function* getOneContact({ payload }) {
  try {
    const { response, error } = yield call(services.contact.getOne, payload)
    if (error) {
      yield put({
        type: GET_ONE_CONTACT_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ONE_CONTACT_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ONE_CONTACT_ERROR,
      payload: 'Error al obtener contacto',
    })
  }
}

function* getAllContacts({ payload }) {
  try {
    const { response, error } = yield call(services.contact.getAll, payload)
    if (error) {
      yield put({
        type: GET_ALL_CONTACTS_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ALL_CONTACTS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_CONTACTS_ERROR,
      payload: 'Error al obtener los contactos',
    })
  }
}

function* newContact({ payload }) {
  try {
    const { response, error } = yield call(services.contact.new, payload)

    if (error) {
      yield put({ type: NEW_CONTACT_ERROR, payload: error })
    } else {
      const currentContacts = yield select(getAllCurrentContacts)
      const oldFeaturedContact = yield call(removeContactFeaturedFlag, { payload, currentContacts })

      const newCurrentContactList = currentContacts?.data?.map(item => {
        if (oldFeaturedContact && oldFeaturedContact?._id === item?._id) {
          return { ...item, ...oldFeaturedContact }
        }

        return item
      })

      yield all([
        put({
          type: NEW_CONTACT_SUCCESS,
          payload: response,
        }),
        put({
          type: UPDATE_CONTACTS,
          payload: { ...currentContacts, data: [...newCurrentContactList, response] },
        }),
      ])
    }
  } catch {
    yield put({
      type: NEW_CONTACT_ERROR,
      payload: 'Error al crear nuevo contacto',
    })
  }
}

function* editContact({ payload }) {
  try {
    const { response, error } = yield call(services.contact.edit, payload)
    if (error) {
      yield put({
        type: EDIT_CONTACT_ERROR,
        payload: error,
      })
    } else {
      const currentContacts = yield select(getAllCurrentContacts)
      const oldFeaturedContact = yield call(removeContactFeaturedFlag, { payload: { _id: payload.idContact, ...payload.body }, currentContacts })

      const newCurrentContactList = currentContacts?.data?.map(item => {
        if (oldFeaturedContact && oldFeaturedContact?._id === item?._id) {
          return { ...item, ...oldFeaturedContact }
        }

        if (item?._id === response?._id) {
          return response
        }

        return item
      })

      yield all([
        put({
          type: EDIT_CONTACT_SUCCESS,
          payload: response,
        }),
        put({
          type: UPDATE_CONTACTS,
          payload: { ...currentContacts, data: newCurrentContactList },
        }),
      ])
    }
  } catch {
    yield put({
      type: EDIT_CONTACT_ERROR,
      payload: 'Error al editar el contacto.',
    })
  }
}

function* deleteContact({ payload }) {
  try {
    const { response, error } = yield call(services.contact.deleteOne, payload)
    if (error) {
      yield put({
        type: DELETE_CONTACT_ERROR,
        payload: error,
      })
    } else {
      const currentContacts = yield select(getAllCurrentContacts)
      const updatedContacts = currentContacts?.data?.filter(contact => contact?._id !== payload.idContact)

      yield all([
        put({
          type: DELETE_CONTACT_SUCCESS,
          payload: response,
        }),
        put({
          type: UPDATE_CONTACTS,
          payload: { ...currentContacts, data: updatedContacts },
        }),
      ])
    }
  } catch {
    yield put({
      type: DELETE_CONTACT_ERROR,
      payload: 'Error al eliminar contacto',
    })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<GetOneContact>(GET_ONE_CONTACT, getOneContact)
  yield takeLatest<GetAllContacts>(GET_ALL_CONTACTS, getAllContacts)
  yield takeLatest<NewContact>(NEW_CONTACT, newContact)
  yield takeLatest<EditContact>(EDIT_CONTACT, editContact)
  yield takeLatest<DeleteContact>(DELETE_CONTACT, deleteContact)
}
